import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ErrorBannerProps {
  /** Renders nothing when falsy, so callers can write
   *  `<ErrorBanner message={cond ? "..." : null} />` inline. */
  message?: string | null;
  className?: string;
  icon?: ReactNode;
}

export function ErrorBanner({ message, className, icon }: ErrorBannerProps) {
  if (!message) return null;
  return (
    <div className={cn("p-3 bg-destructive/10 border border-destructive/30 rounded-lg", className)}>
      <p className="text-sm text-destructive font-medium flex items-center gap-2">
        {icon ?? <AlertCircle className="w-4 h-4 shrink-0" />}
        {message}
      </p>
    </div>
  );
}
